import { render, staticRenderFns } from "./send-candidate-ask.vue?vue&type=template&id=04fb25db&scoped=true"
import script from "./send-candidate-ask.vue?vue&type=script&lang=ts"
export * from "./send-candidate-ask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb25db",
  null
  
)

export default component.exports